import React ,{useEffect}from "react";
import { Col, Container, Row } from "react-bootstrap";

export const TermsConditions = () => {
   useEffect(() => {
     window.scrollTo(0, 0);
   }, []);
  return (
    <>
      <Container>
        <Row className="my-4">
          <Col className="terms">
            <h3>Terms and Conditions</h3>
            <p>
              Terms & Conditions –Sri MangalambikaStores <br /><br/>{" "}
              <b>Effective Date:</b> 01/08/2025 Welcome to Sri
              MangalambikaStores. <br />
              <br />
              These terms and conditions govern your use of our website and our
              services. By accessing or using our website, you agree to be bound
              by thetermsbelow.
              <br />
              <br />
              <b>1.Products & price :</b> We offer a range of traditional iron,
              cast iron, and bronze cookware products. All items are handcrafted
              or semi-handcrafted and may vary slightly in shape, weight, or
              appearance. Product descriptions, images, and prices are provided
              for reference and may be updated at any timewithoutnotice. Prices
              shown include applicable taxes unless otherwisestated.
              <br /> <br />
              <b>2.Ordering & Payments :</b> Orders must be placed through our
              secure website. Accepted payment modes include UPI, credit/debit
              cards, net banking. Orders are processed only after payment is
              successfullycompleted. We reserve the right to cancel or refuse
              any order atourdiscretion.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};
